module.exports = "  <img style=\"width: 100%;\" src=\"https://api.municipal.gov.ge/fs/picture/{{data.imageId}}\" alt=\"\">"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/image-dialog/image-dialog.component.html
// module id = ../../../../../src/app/components/admin/components/shared/petition-details/dialogs/image-dialog/image-dialog.component.html
// module chunks = main